<script setup lang="ts">
const retryAuth = () => {
  // Reload the page to try again
  window.location.reload()
}
</script>
<!-- AuthErrorPage.vue -->
<template>
  <div class="flex justify-center items-center min-h-screen bg-gray-50">
    <div class="max-w-md w-full p-8 bg-white rounded-lg shadow-md text-center">
      <h1 class="text-2xl font-bold text-gray-800 mb-4">Authentication Error</h1>
      <div class="flex justify-center my-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-16 w-16 text-red-500"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
      <p class="text-gray-600 mb-6">Report this issue</p>
      <div>
        <button
          @click="retryAuth"
          class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  </div>
</template>
